import React from 'react';
import { ModalProvider } from 'design-system/src/hooks/useModal';
import 'design-system/src/scss/main.scss';

import locales from './locales.json';

export { wrapRootElement } from './gatsby-shared';

function getNewRouteLang(pathname) {
    if (!pathname) {
        return null;
    }

    let parts = pathname?.split('/').filter((i) => !!i);

    if (!parts.length) {
        return null;
    }

    if (locales.indexOf(parts[0]) !== -1) {
        return parts[0];
    }

    return null;
}

// Force scroll to top on new navigation. Restores saved position when the
// user uses browser back/forward.
export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
}) => {
    const savedPosition = getSavedScrollPosition(location);
    if (savedPosition) {
        return savedPosition;
    }
    return [0, 0];
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    const routeLang = getNewRouteLang(location.pathname);

    // Set cookie with new language
    if (routeLang) {
        window.document.cookie = `pr_lng=${routeLang}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
    }

    if (window._hsq && prevLocation?.pathname && location.pathname) {
        window._hsq.push(['setPath', location.pathname]);
        window._hsq.push(['trackPageView']);
    }
};

// Wrap page element with ModalProvider
export const wrapPageElement = ({ element, props }) => {
    return <ModalProvider>{element}</ModalProvider>;
};

export const onClientEntry = () => {
    if (process.env.GATSBY_GTM_ID) {
        window.dataLayer = window.dataLayer || [];

        function gtag() {
            window.dataLayer.push(arguments);
        }

        var _hsp = window._hsp = window._hsp || [];
        _hsp.push(['addPrivacyConsentListener', function (consent) {
            var hasAnalyticsConsent = consent && (consent.allowed || (consent.categories && consent.categories.analytics));
            var hasAdsConsent = consent && (consent.allowed || (consent.categories && consent.categories.advertisement));

            gtag('consent', 'update', {
                'ad_storage': hasAdsConsent ? 'granted' : 'denied',
                'analytics_storage': hasAnalyticsConsent ? 'granted' : 'denied',
                'ad_user_data': hasAdsConsent ? 'granted' : 'denied',
                'ad_personalization': hasAdsConsent ? 'granted' : 'denied'
            });

            gtag('event', 'hubspotConsentUpdate');
        }]);
    }
};
